import React, { useState } from "react";
import {
    Outlet,
    useLocation,
    useNavigate,
    useParams,
} from "react-router-dom";

import {
    Button,
    Group,
    Modal,
    PasswordInput,
    Stack,
    Text,
} from "@mantine/core";

import "./playerLoungeFood.css";

const SETTINGS_PIN = "1793";
const SETTINGS_SESSION_KEY = "foodSettingsUnlocked";

export default function FoodLayout() {
    const navigate = useNavigate();
    const location = useLocation();

    const { eventId } =
        useParams<{ eventId: string }>();

    const basePath =
        `/Food/${eventId}`;

    const [pinModalOpen, setPinModalOpen] =
        useState(false);

    const [pin, setPin] =
        useState("");

    const [pinError, setPinError] =
        useState("");

    function isActive(path: string) {
        return (
            location.pathname.toLowerCase() ===
            path.toLowerCase()
        );
    }

    function openSettings() {
        const alreadyUnlocked =
            sessionStorage.getItem(
                SETTINGS_SESSION_KEY
            ) === "true";

        if (alreadyUnlocked) {
            navigate(
                `${basePath}/settings`
            );

            return;
        }

        setPin("");
        setPinError("");
        setPinModalOpen(true);
    }

    function submitPin() {
        if (pin === SETTINGS_PIN) {
            sessionStorage.setItem(
                SETTINGS_SESSION_KEY,
                "true"
            );

            setPinModalOpen(false);
            setPin("");
            setPinError("");

            navigate(
                `${basePath}/settings`
            );

            return;
        }

        setPinError(
            "Forkert PIN-kode."
        );
    }

    function openKitchen() {
        window.open(
            `${basePath}/kitchen`,
            "_blank",
            "noopener,noreferrer"
        );
    }

    return (
        <div className="pl-page">
            <aside className="pl-sidebar">

                <div className="pl-logo">
                    PLAYER
                    <br />
                    LOUNGE
                </div>

                <button
                    type="button"
                    className={`pl-nav ${isActive(basePath)
                            ? "active"
                            : ""
                        }`}
                    onClick={() =>
                        navigate(basePath)
                    }
                >
                    🛒 Ny ordre
                </button>

                <button
                    type="button"
                    className={`pl-nav ${isActive(
                        `${basePath}/orders`
                    )
                            ? "active"
                            : ""
                        }`}
                    onClick={() =>
                        navigate(
                            `${basePath}/orders`
                        )
                    }
                >
                    🧾 Ordrer
                </button>

                <button
                    type="button"
                    className="pl-nav"
                    onClick={
                        openKitchen
                    }
                >
                    🖥 Køkken skærm
                </button>

                <button
                    type="button"
                    className={`pl-nav ${isActive(
                        `${basePath}/history`
                    )
                            ? "active"
                            : ""
                        }`}
                    onClick={() =>
                        navigate(
                            `${basePath}/history`
                        )
                    }
                >
                    ◷ Historik
                </button>

                <button
                    type="button"
                    className={`pl-nav ${isActive(
                        `${basePath}/settings`
                    )
                            ? "active"
                            : ""
                        }`}
                    onClick={
                        openSettings
                    }
                >
                    ⚙ Indstillinger
                </button>

            </aside>

            <main className="pl-main">
                <Outlet />
            </main>

            {/* PIN MODAL */}

            <Modal
                opened={pinModalOpen}
                onClose={() => {
                    setPinModalOpen(false);
                    setPin("");
                    setPinError("");
                }}
                title="Adgang til indstillinger"
                centered
                size="sm"
            >
                <Stack>
                    <Text
                        size="sm"
                        c="dimmed"
                    >
                        Indtast PIN-koden for
                        at åbne Player Lounge
                        indstillinger.
                    </Text>

                    <PasswordInput
                        label="PIN-kode"
                        placeholder="Indtast PIN"
                        value={pin}
                        onChange={e => {
                            setPin(
                                e.currentTarget.value
                            );

                            setPinError("");
                        }}
                        error={
                            pinError ||
                            undefined
                        }
                        maxLength={4}
                        autoFocus
                        onKeyDown={e => {
                            if (
                                e.key === "Enter"
                            ) {
                                e.preventDefault();
                                submitPin();
                            }
                        }}
                    />

                    <Group
                        justify="flex-end"
                        mt="sm"
                    >
                        <Button
                            variant="default"
                            onClick={() =>
                                setPinModalOpen(
                                    false
                                )
                            }
                        >
                            Annuller
                        </Button>

                        <Button
                            onClick={
                                submitPin
                            }
                            disabled={
                                pin.length !== 4
                            }
                        >
                            Åbn
                        </Button>
                    </Group>
                </Stack>
            </Modal>
        </div>
    );
}